import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#b1b5c4",
      "fill-rule": "evenodd",
      d: "M12 13a7 7 0 0 0-7 7v2a1 1 0 1 1-2 0v-2a9 9 0 1 1 18 0v2a1 1 0 1 1-2 0v-2a7 7 0 0 0-7-7",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#b1b5c4",
      "fill-rule": "evenodd",
      d: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 2a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }